export const GET_PROJECTS_QUERY = `
    query Projects ($account_id: Int, $workspace_id: Int, $admin: Boolean, $shared: Boolean) {
        projects (account_id: $account_id, workspace_id: $workspace_id, admin: $admin, shared: $shared) {
            id
            name
            unique_id
            due_date
            creator_count
            image
            theme
            workspace {
                id
                name
                image
                archived
            }
            account {
                id
                name
                type
                image
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const GET_PROJECT_QUERY = `
    query Project($project_id: Int!) {
        project(project_id: $project_id) {
            id
            name
            unique_id
            due_date
            creator_count
            image
            theme
            custom_properties {
                key
                value
            }
            workspace {
                id
                name
                image
                archived
                account {
                    id
                    name
                    image
                    type
                }
                custom_properties {
                    key
                    value
                }
            }
            account {
                id
                name
                image
                type
            }
        }
    }
`;

// export const GET_PROJECT_QUERY = `
//     query Project($project_id: Int!) {
//         project(project_id: $project_id) {
//             id
//             name
//             due_date
//             creator_count
//             image
//             workspace {
//                 id
//                 name
//                 image,
//                 account {
//                     id
//                     name
//                     type
//                 }
//             }
//             account {
//                 id
//                 name
//                 type
//             }
//         }
//     }
// `;

export const GET_PROJECT_VIEWS_QUERY = `
    query Views($project_id: Int!) {
        views(project_id: $project_id) {
            id
            name
            base
            display_mode
            column_state
            grouping
            filter
            hidden_fields
            blocked
            sort
            shared
            locked
            custom_properties {
                key
                value
            }

        }
    }
`;

export const GET_PROJECT_ENTITY_MAPPING_QUERY = `
    query EntityMappings($project_id: Int!, $entity_name: [EntityModelEnum]) {
        entityMappings(project_id: $project_id, entity_name: $entity_name) {
            id
            field
            entity
            type
            options
            created_at
        }
    }
`;

export const GET_PROJECT_COMMENTS_QUERY = `
    query Comments($project_id: Int!, $topic_id: Int!, $project_creator_id: Int!, $content_id: Int!, $submission_asset_id: Int!, $page: Int!, $limit: Int!) {
        comments(project_id: $project_id, topic_id: $topic_id, project_creator_id: $project_creator_id, content_id: $content_id, submission_asset_id: $submission_asset_id, page: $page, limit: $limit) {
            id
            project_id
            project_creator_id
            topic
            parent_id
            content_id
            body
            timestamp
            created_at
        }
    }
`;

export const GET_PROJECT_CREATORS_QUERY = `
    query Creators($project_id: Int!) {
        creators(project_id: $project_id) {
            id
            deliverable_count
            account_creator {
                id
                username
                sortname
                type
                first_name
                last_name
                email
                phone
                avatar
                ethnicity
                gender
                verticals
                w9
                w9_expiration_date
                created_at
                updated_at
                social_channels {
                    id
                    handle
                    label
                    description
                    type
                    url
                    avatar
                }
                custom_properties {
                        key
                        value
                }
            }
            social_channels {
                id
                handle
                description
                type
                url
                avatar
                reach
                impressions
            }
            associates {
                id
                type
            }
            documents {
                id
                project_id
                project_creator_id
                uploaded_by
                tag
                path
                filename
                label
                thumbnail
                type
                created_at
                updated_at
                project_creator {
                    id
                    notes
                    client_notes
                    initial_quote
                    favorite
                    confirmed
                    example_content
                    avatar
                    decision
                    tiktok_reach
                    tiktok_impressions
                    tiktok_engagement_rate
                    instagram_reach
                    instagram_impressions
                    instagram_engagement_rate
                    youtube_reach
                    youtube_impressions
                    youtube_engagement_rate
                    account_creator {
                        id
                        username
                        sortname
                    }
                }
            }
            deliverables {
                id
                name
                type
                status
                due_date
                draft_due_date
                target_live_date
                notes
                assets {
                    id
                    versions {
                        id
                        title
                        description
                        version
                        status
                    }
                }
                creator {
                    id
                    account_creator {
                        id
                        username
                        avatar
                    }
                }
                products  {
                    id
                    name
                    image_url
                    custom_properties {
                        key
                        value
                    }
                    product_retailers {
                        id
                        sku
                        url
                        image_url
                    }
                }
                destinations {
                    id
                    url
                    status
                    account_social_channel {
                        id
                        handle
                        type
                        url
                        avatar
                    }
                }
                custom_properties {
                    key
                    value
                }
            }
            contract {
                id
                status
                contract_value
                kill_fee
                content_ownership_id
                content_rights
                content_rights_expiration_date
                ecom_asset_ownership
                indeminity
                whitelisting
                whitelisting_expiration
                term_date
                notes
                uploads {
                    id
                    filename
                    thumbnail
                    tag
                    type
                }
            }
            custom_properties {
                key
                value
            }
            notes
            initial_quote
            favorite
            confirmed
            example_content
            avatar
            decision
            tiktok_reach
            tiktok_impressions
            tiktok_engagement_rate
            instagram_reach
            instagram_impressions
            instagram_engagement_rate
            youtube_reach
            youtube_impressions
            youtube_engagement_rate
            client_notes
            products {
                id
                name
                image_url
                custom_properties {
                    key
                    value
                }
                product_retailers {
                    id
                    sku
                    url
                    image_url
                }
            }
            invite {
                has_email
                error
                deliverables
                accepted
                invited
                status
                link
            }
            briefing_files {
                id
                deliverable_id
                filename
                thumbnail
                tag
                type
            }
        }
    }
`;

export const GET_PROJECT_DELIVERABLE_ASSETS_QUERY = `
    query DeliverableAsset($project_id: Int!, $media_id: Int!) {
        deliverableAsset(project_id: $project_id, media_id: $media_id) {
            id
        }
    }
`;

export const GET_PROJECT_DELIVERABLES_QUERY = `
    query Deliverables($project_id: Int!, $project_creator_id: Int, $account_creator_id: Int) {
        deliverables(project_id: $project_id, project_creator_id: $project_creator_id, account_creator_id: $account_creator_id) {
            id
            name
            type
            status
            due_date
            draft_due_date
            target_live_date
            notes
            current_asset_version_number
            current_asset_version {
                id
                name
                type
                status
                account_id
                workspace_id
                description
                uploaded_filename
                orientation
                filesize
                timestamp
                thumbnail
                still
                video_path
                image_path
                created_at
                updated_at
                uploaded_at
                version
            }
            current_asset_version_uploaded_at
            assets {
                id
                destination_metadata {
                    id
                    destination_id
                    title
                    description
                }
                current_version {
                    id
                    name
                    type
                    status
                    account_id
                    workspace_id
                    description
                    version
                    uploaded_filename
                    orientation
                    filesize
                    timestamp
                    thumbnail
                    still
                    video_path
                    image_path
                    created_at
                    updated_at
                    uploaded_at
                }
                versions {
                    id
                    title
                    description
                    version
                    status
                    media {
                        id
                        name
                        type
                        status
                        description
                        uploaded_filename
                        orientation
                        filesize
                        timestamp
                        thumbnail
                        still
                        video_path
                        image_path
                        created_at
                        updated_at
                        uploaded_at
                    }
                }
            }
            creator {
                id
                deliverable_count
                notes
                initial_quote
                favorite
                confirmed
                example_content
                avatar
                decision
                tiktok_reach
                tiktok_impressions
                tiktok_engagement_rate
                instagram_reach
                instagram_impressions
                instagram_engagement_rate
                youtube_reach
                youtube_impressions
                youtube_engagement_rate
                client_notes
                briefing_files {
                        id
                        filename
                        deliverable_id
                        label
                        thumbnail
                        tag
                        type
                        uploaded_by {
                            id
                            first_name
                            last_name
                            username
                            email
                            phone
                            avatar
                            verified
                            last_login
                        }
                    }
                social_channels {
                    id
                    label
                    handle
                    description
                    type
                    url
                    avatar
                    reach
                    impressions
                }
                account_creator {
                    id
                    sortname
                    username
                    type
                    first_name
                    last_name
                    email
                    phone
                    avatar
                    ethnicity
                    gender
                    verticals
                    w9
                    w9_expiration_date
                    created_at
                    updated_at
                    custom_properties {
                        key
                        value
                    }
                    social_channels {
                        id
                        handle
                        label
                        description
                        type
                        url
                        avatar
                    }
                }
                contract {
                    id
                    status
                    contract_value
                    kill_fee
                    content_ownership_id
                    content_rights
                    content_rights_expiration_date
                    ecom_asset_ownership
                    ecom_asset_expiration_date
                    indeminity
                    whitelisting
                    whitelisting_expiration
                    term_date
                    notes
                },
                custom_properties {
                    key
                    value
                }
                documents {
                    id
                    project_id
                    project_creator_id
                    uploaded_by
                    tag
                    path
                    filename
                    label
                    thumbnail
                    type
                    created_at
                    updated_at
                    project_creator {
                        id
                        notes
                        client_notes
                        initial_quote
                        favorite
                        confirmed
                        example_content
                        avatar
                        decision
                        tiktok_reach
                        tiktok_impressions
                        tiktok_engagement_rate
                        instagram_reach
                        instagram_impressions
                        instagram_engagement_rate
                        youtube_reach
                        youtube_impressions
                        youtube_engagement_rate
                        account_creator {
                            id
                            username
                            sortname
                        }
                    }
                }
            }
            products  {
                id
                name
                image_url
                custom_properties {
                    key
                    value
                }
                product_retailers {
                    id
                    sku
                    url
                    image_url
                }
            }
            destinations {
                id
                url
                status
                account_social_channel {
                    id
                    handle
                    label
                    description
                    type
                    url
                    avatar
                }
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const GET_PROJECT_CREATOR_DOCUMENTS_QUERY = `
    query CreatorDocuments($project_id: Int!, $project_creator_id: Int) {
        creatorDocuments(project_id: $project_id, project_creator_id: $project_creator_id) {
            id
            project_id
            project_creator_id
            uploaded_by
            tag
            path
            filename
            label
            thumbnail
            type
            created_at
            updated_at
            project_creator {
                id
                deliverable_count
                notes
                client_notes
                initial_quote
                favorite
                confirmed
                example_content
                avatar
                decision
                tiktok_reach
                tiktok_impressions
                tiktok_engagement_rate
                instagram_reach
                instagram_impressions
                instagram_engagement_rate
                youtube_reach
                youtube_impressions
                youtube_engagement_rate
                account_creator {
                    id
                    username
                    sortname
                    type
                    first_name
                    last_name
                    email
                    phone
                    avatar
                    ethnicity
                    gender
                    verticals
                    w9
                    w9_expiration_date
                    created_at
                    updated_at
                    custom_properties {
                        key
                        value
                    }
                }
                associates {
                    id
                    type
                }
                deliverables {
                    id
                    name
                    type
                    status
                    due_date
                    draft_due_date
                    target_live_date
                    notes
                    current_asset_version_number
                    current_asset_version_uploaded_at
                    custom_properties {
                        key
                        value
                    }
                }
                social_channels {
                    id
                    label
                    handle
                    description
                    type
                    url
                    avatar
                    reach
                    impressions
                }
                contract {
                    id
                    status
                    contract_value
                    kill_fee
                    content_ownership_id
                    content_rights
                    content_rights_expiration_date
                    ecom_asset_ownership
                    ecom_asset_expiration_date
                    indeminity
                    whitelisting
                    whitelisting_expiration
                    term_date
                    notes
                }
                custom_properties {
                    key
                    value
                }
                products {
                    id
                    name
                    image_url
                    archived
                }
                briefing_files {
                    id
                    deliverable_id
                    filename
                    label
                    thumbnail
                    tag
                    type
                }
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const GET_PROJECT_PRODUCTS_QUERY = `
    query Products($project_id: Int!) {
        products(project_id: $project_id) {
            id
            name
            image_url
        }
    }
`;

export const GET_PROJECT_BRIEF_FILES_QUERY = `
    query Briefs($project_id: Int!) {
        briefs(project_id: $project_id) {
            id
            deliverable_id
            filename
            thumbnail
            tag
            type
            uploaded_by {
                avatar
                username
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const GET_PROJECT_BRIEF_LINK_QUERY = `
    query downloadBrief($project_id: Int!, $upload_id: Int!) {
        downloadBrief(project_id: $project_id, upload_id: $upload_id)  {
            filename
            url
        }
    }
`;

export const GET_PROJECT_CREATOR_DOCUMENT_LINK_QUERY = `
    query downloadCreatorDocument($project_id: Int!, $document_id: Int!) {
        downloadCreatorDocument(project_id: $project_id, document_id: $document_id)  {
            filename
            url
        }
    }
`;

export const GET_DELIVERABLE_MEDIA_ASSETS = `
query Deliverables ($project_id: Int!, $media_id: Int, $project_creator_id: Int, $account_creator_id: Int) {
    deliverables(project_id: $project_id, media_id: $media_id, project_creator_id: $project_creator_id, account_creator_id: $account_creator_id) {
        id
        name
        status
        type
        due_date
        draft_due_date
        target_live_date
        notes
        assets {
            id
            versions {
                id
                title
                description
                version
                status
                media {
                    id
                    name
                    type
                    status
                    description
                    uploaded_filename
                    orientation
                    filesize
                    timestamp
                    thumbnail
                    still
                    video_path
                    image_path
                    created_at
                    updated_at
                    uploaded_at
                }
            }
            destination_metadata {
                id
                destination_id
                title
                description
            }
        }
        products  {
            id
            name
            image_url
            custom_properties {
                key
                value
            }
            product_retailers {
                id
                sku
                url
                image_url
            }
        }
        destinations {
            id
            url
            status
            account_social_channel {
                id
                handle
                label
                description
                type
                url
                avatar
            }
        }
    }
}`;

export const GET_PROJECT_NOTIFICATION_USERS = `
  query NotificationUsers($project_id: Int!) {
    notificationUsers(project_id: $project_id) {
      id
      user_id
      type_id
      created_at
      user {
        id
        avatar
        first_name
        last_name
        email
      }
    }
  }
`;
